import React from 'react';

import {SvgIcon} from '@material-ui/core';

import * as colors from 'assets/theme/colors';
import {ContentItem, ModuleItem} from 'commons/types/Types';
import {ReactComponent as EditIcon} from 'assets/icons/section/action/edit.svg';
import {ReactComponent as OwnerIcon} from 'assets/icons/section/menu/profile.svg';
import {ReactComponent as CardIcon} from 'assets/icons/section/menu/my-cards.svg';
import {ReactComponent as DocIcon} from 'assets/icons/section/miscelaneous/doc.svg';
import {ReactComponent as DownIcon} from 'assets/icons/section/navigation/down.svg';
import {ReactComponent as LegalIcon} from 'assets/icons/section/miscelaneous/legal.svg';
import {ReactComponent as MoneyIcon} from 'assets/icons/section/miscelaneous/money.svg';
import {ReactComponent as TokenIcon} from 'assets/icons/section/miscelaneous/token.svg';
import {ReactComponent as LocationIcon} from 'assets/icons/section/miscelaneous/location.svg';
import {ReactComponent as UsersIcon} from 'assets/icons/section/miscelaneous/affiliates.svg';
import {ReactComponent as ConsigneeIcon} from 'assets/icons/section/miscelaneous/contact.svg';
import {ReactComponent as MailIcon} from 'assets/icons/section/miscelaneous/mailbox.svg';

function isModule(contentItem: ContentItem): contentItem is ModuleItem {
    return (contentItem as ModuleItem).items !== undefined;
}

/**
 * Generate an array of PageRef items
 * @param {ContentItem[]} pages
 * @returns {PageRef[]}
 */
function getModuleItems(pages: ModuleItem[]): ContentItem[] {
    const arrayPages: ContentItem[] = [];
    for (const item of pages) {
        if (item.items) {
            arrayPages.push(...getModuleItems(item.items as ModuleItem[]));
        } else {
            arrayPages.push(item as ContentItem);
        }
    }
    return arrayPages;
}

const getIcon = (name: string) => {
    let Icon;
    switch (name) {
        case 'action-edit': {
            Icon = EditIcon;
            break;
        }
        case 'misc-doc': {
            Icon = DocIcon;
            break;
        }
        case 'misc-location': {
            Icon = LocationIcon;
            break;
        }
        case 'down': {
            Icon = DownIcon;
            break;
        }
        case 'legal': {
            Icon = LegalIcon;
            break;
        }
        case 'card': {
            Icon = CardIcon;
            break;
        }
        case 'money': {
            Icon = MoneyIcon;
            break;
        }
        case 'owner': {
            Icon = OwnerIcon;
            break;
        }
        case 'token': {
            Icon = TokenIcon;
            break;
        }
        case 'users': {
            Icon = UsersIcon;
            break;
        }
        case 'mail-box': {
            Icon = MailIcon;
            break;
        }
        case 'consignee': {
            Icon = ConsigneeIcon;
            break;
        }
        default: {
            Icon = EditIcon;
            break;
        }
    }

    if ('no-icon' !== name) {
        return (
            <SvgIcon style={{color: colors.neutrals.A10}}>
                <Icon stroke={colors.neutrals.A10} />
            </SvgIcon>
        );
    } else {
        return null;
    }
};

function findSubModule(items: Array<ModuleItem>, active: string) {
    let flag = false;
    for (const item of items) {
        if (item.thirdLevel && item.items) {
            flag =
                item.items.filter((submodule: ModuleItem) => `${submodule.viewId}` === active)
                    .length > 0;
        } else {
            flag =
                items.filter((submodule: ModuleItem) => `${submodule.viewId}` === active).length >
                0;
        }
        if (flag) {
            break;
        }
    }
    return flag;
}

export {getModuleItems, isModule, getIcon, findSubModule};
